import type { FieldData } from "antd/node_modules/rc-field-form/lib/interface";

/**
 * @name setValue 更新 “指定字段” 值
 */
export function setValue(
  data: Record<string, any> | any[],
  { name, value }: FieldData,
) {
  const [key, ...rest] = name;
  if (!rest.length) {
    data[key] = value;
    return;
  }
  if (data[key] === null || data[key] === undefined) {
    data[key] = typeof rest[0] === "number" ? [] : {};
  }
  setValue(data[key], { name: rest, value });
}

/**
 * @name getValue 获取 “指定字段” 值
 */
export function getValue(
  data: Record<string, any> | any[],
  name: (string | number)[],
): any | undefined {
  if (!name.length) return data;
  const [key, ...rest] = name;
  if (data == null || data[key] == null) {
    return undefined;
  }

  return getValue(data[key], rest);
}
